import { IAddLoanPartner } from "pages/admin/financial-partners/add";
import { IAddLoanProductForm } from "pages/admin/financial-partners/add-product/[id]";
import { IEditLoanProductForm } from "pages/admin/financial-partners/edit-product/[id]";
import { API, Http } from "services/http/http";
import { paramsObjectToQueryString } from "utils/generic-utils";

export const fetchLoanProducts = () => Http.get(`/loan/product`);

export const fetchLoanApplications = (payload?: {}) =>
   Http.get(`/loan/application${paramsObjectToQueryString(payload)}`);

export const searchLoanApplications = (val: string) => Http.get(`/loan/application?search=${val}`);

export const fetchLoanApplicationCount = () => Http.get(`/loan/application/count`);

export const fetchFilteredApplicationCount = (interval: string, status: string) =>
   Http.get(`/loan/application/count?interval=${interval}${status ? `&status=${status}` : ""}`);

export const fetchAllLoanProducts = () =>
   API({
      method: "GET",
      url: `/loans`,
   });

export const fetchLoanProduct = (payload) =>
   API({
      method: "GET",
      url: `/loans${paramsObjectToQueryString(payload)}`,
   });

// export const createLoanProduct = (payload: IAddLoanPartner) => Http.post("/loan/product", payload);
export const createLoanPartner = (payload: IAddLoanPartner) => Http.post("/loan/product", payload);

export const createLoanProduct = (payload: IAddLoanProductForm) =>
   Http.post("/loan/product/create", payload);

export const updateLoanProduct = (payload: IEditLoanProductForm, id: string) =>
   Http.put(`/loan/product/${id}`, payload);

export const createLoanApplication = (payload: IAddLoanPartner) =>
   Http.post("/loan/application", payload);

export const updateLoanApplication = (id: string, payload: Record<string, string>) =>
   Http.put(`/loan/application/${id}`, payload);

export const updateLoanPartner = (id: string, payload: Record<string, string | boolean>) =>
   Http.put(`/loan/product/financial-partner/${id}`, payload);

export const fetchSingleLoanProduct = (token, { queryKey }) =>
   Http.get(`/loans/${queryKey[1]}`, {
      headers: {
         authorization: token,
      },
   });

export const fetchSingleLoanApplication = (id, token) =>
   Http.get(`/loan/application/${id}`, {
      headers: {
         authorization: token,
      },
   });

export const searchLoanPartners = (val: string) => Http.get(`/loan/product?search=${val}`);

export const fetchPartners = (payload) =>
   API({
      method: "GET",
      url: `/loan/product${paramsObjectToQueryString(payload)}`,
   });

export const fetchServerLoanProducts = (token) =>
   Http.get(`/loan/product`, {
      headers: {
         authorization: token,
      },
   });

export const deleteLoanProduct = (id: string) => Http.delete(`/loan/product/${id}`);

export const fetchSingleLoanProductUser = (id) => Http.get(`/loans/${id}`);

export const requestCallBack = (payload) => Http.post("/loan-callback", payload);

export const fetchLoanRequests = (payload?: {}) =>
   Http.get(`/loan-callback${paramsObjectToQueryString(payload)}`);

export const requestSchoolLoan = (payload) => Http.post("/loan/application/school", payload);

export const fetchLoanRequestsSchool = (payload?: {}) =>
   Http.get(`/loan/application/school${paramsObjectToQueryString(payload)}`);
